// Global toast banner for sticky bar & floating cart/size error notifications
window.showStickyErrorMessage = function(message) {
  if (!message) return;

  // Do not show sticky error toast if quick add/view modal is open
  if (document.querySelector('quick-add-modal[open], .quick-add-modal[open]')) {
    return;
  }

  const isQtyLimitError = message.toLowerCase().includes('maximum quantity') || message.toLowerCase().includes('already in your cart');

  if (window.innerWidth < 750) {
    // On mobile, only show this specific error message when the mobile sticky cart exists in the DOM
    if (!isQtyLimitError) {
      return;
    }
    const mobileStickyCart = document.querySelector('.mobile-sticky-cart');
    if (!mobileStickyCart) {
      return;
    }
  } else {
    // Only show toast on desktop viewports when the PDP sticky bar is active/visible
    const stickyBar = document.querySelector('desktop-sticky-bar');
    const isStickyBarVisible = stickyBar && !stickyBar.classList.contains('desktop-sticky-bar--hidden');
    if (!isStickyBarVisible) {
      return;
    }
  }


  if (!document.getElementById('sticky-error-toast-styles')) {
    const style = document.createElement('style');
    style.id = 'sticky-error-toast-styles';
    style.textContent = `
      .sticky-error-toast {
        position: fixed;
        bottom: 82px;
        left: 50%;
        transform: translateX(-50%) translateY(20px);
        background: #ffffff;
        color: #121212;
        border: 1px solid #e5e5e5;
        border-left: 4px solid #e22120;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
        padding: 12px 16px 12px 18px;
        border-radius: 8px;
        z-index: 2147483647;
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.4;
        opacity: 0;
        pointer-events: none;
        transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease;
        max-width: 90vw;
        box-sizing: border-box;
        cursor: pointer;
      }
      .sticky-error-toast.active {
        opacity: 1;
        pointer-events: auto;
        transform: translateX(-50%) translateY(0);
      }
      .sticky-error-toast__icon {
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }
      .sticky-error-toast__message {
        color: #121212;
        font-family: inherit;
        flex-grow: 1;
      }
      .sticky-error-toast__close {
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 4px;
        color: #888888;
        border-radius: 50%;
        transition: color 0.2s ease, background 0.2s ease;
        flex-shrink: 0;
      }
      .sticky-error-toast__close:hover {
        color: #121212;
        background: #f0f0f0;
      }
      @media screen and (max-width: 749px) {
        .sticky-error-toast {
          bottom: 75px;
          width: calc(100vw - 32px);
          max-width: 480px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // Remove existing active toast cleanly
  if (window._dismissStickyToast) window._dismissStickyToast();

  const toast = document.createElement('div');
  toast.className = 'sticky-error-toast';
  toast.setAttribute('role', 'alert');
  toast.innerHTML = `
    <span class="sticky-error-toast__icon">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="#E22120"/>
        <path d="M12 7V13" stroke="white" stroke-width="2.2" stroke-linecap="round"/>
        <circle cx="12" cy="16.5" r="1.1" fill="white"/>
      </svg>
    </span>
    <span class="sticky-error-toast__message">${message}</span>
    <button type="button" class="sticky-error-toast__close" aria-label="Close message">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  `;

  document.body.appendChild(toast);

  // Position toast dynamically above the mobile sticky cart if on mobile
  if (window.innerWidth < 750) {
    const mobileStickyCart = document.querySelector('.mobile-sticky-cart');
    if (mobileStickyCart) {
      const isMobileStickyCartVisible = !mobileStickyCart.classList.contains('mobile-sticky-cart--hidden');
      if (isMobileStickyCartVisible) {
        const bottomOffset = mobileStickyCart.offsetHeight + 12; // 12px spacing above the mobile sticky cart
        toast.style.bottom = `${bottomOffset}px`;
      } else {
        const bottomNav = document.getElementById('mobile-bottom-nav');
        const isBottomNavVisible = bottomNav && !bottomNav.classList.contains('mobile-bottom-nav--hidden');
        if (isBottomNavVisible) {
          toast.style.bottom = `${bottomNav.offsetHeight + 12}px`;
        } else {
          toast.style.bottom = '16px';
        }
      }
    }
  }

  let dismissed = false;
  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;
    toast.classList.remove('active');
    setTimeout(() => toast.remove(), 350);
    document.removeEventListener('click', onClickOutside, true);
    document.removeEventListener('touchstart', onClickOutside, true);
    window._dismissStickyToast = null;
  };

  window._dismissStickyToast = dismiss;

  const onClickOutside = (e) => {
    if (e.target && (e.target.closest('.mobile-sticky-cart') || e.target.closest('desktop-sticky-bar'))) {
      return;
    }
    if (!toast.contains(e.target)) {
      dismiss();
    }
  };

  // Close button click handler
  const closeBtn = toast.querySelector('.sticky-error-toast__close');
  if (closeBtn) closeBtn.addEventListener('click', dismiss);

  // Click on toast itself also dismisses immediately
  toast.addEventListener('click', (e) => {
    if (!e.target.closest('.sticky-error-toast__close')) {
      dismiss();
    }
  });

  requestAnimationFrame(() => {
    toast.classList.add('active');
  });

  // Attach global click & touchstart listeners in capture phase (true)
  setTimeout(() => {
    document.addEventListener('click', onClickOutside, true);
    document.addEventListener('touchstart', onClickOutside, true);
  }, 100);

  if (window._stickyErrorTimeout) clearTimeout(window._stickyErrorTimeout);
  window._stickyErrorTimeout = setTimeout(() => {
    dismiss();
  }, 5000);
};

// ─── Shared size-input finder ────────────────────────────────────────────────
// Uses native CSS selector engine (much faster than querySelectorAll('input,select') + JS filter).
// Covers: fieldset[data-option-name*=size], wrapper[data-option-name*=size], input/select[name*=size].
function getSizeInputs(container) {
  return Array.from(container.querySelectorAll(
    'fieldset[data-option-name*="size" i] input,' +
    'fieldset[data-option-name*="size" i] select,' +
    '[data-option-name*="size" i] input,' +
    '[data-option-name*="size" i] select,' +
    'input[name*="size" i],' +
    'select[name*="size" i]'
  ));
}

// Global capture-phase handler — shows spinner INSTANTLY on any product-form submit button click
// Runs before all other handlers, independent of custom element lifecycle
document.addEventListener('click', (e) => {
  // 1. Instant visual feedback for size picker clicks (Optimistic UI)
  const sizeLabel = e.target.closest('fieldset[data-option-name*="size" i] label, [data-option-name*="size" i] label, .product-form__input--pill[data-option-name*="size" i] label, label[for*="size" i]');
  if (sizeLabel && !sizeLabel.classList.contains('disabled')) {
    const parent = sizeLabel.closest('fieldset, .product-form__input');
    if (parent) {
      parent.querySelectorAll('label').forEach(lbl => lbl.classList.remove('active-instant'));
      sizeLabel.classList.add('active-instant');

      // Instantly clear validation errors on click (0ms)
      const container = parent.closest('product-info') || parent.closest('quick-add-modal') || document;
      container.querySelectorAll('.size-error-message').forEach(el => el.remove());
      container.querySelectorAll('.size-validation-error').forEach(el => el.classList.remove('size-validation-error'));
      document.querySelectorAll('.sticky-error-toast').forEach(el => el.remove());
    }
  }


  const btn = e.target.closest('.product-form__submit[type="submit"], .quick-add__submit[type="submit"], .shopify-payment-button__button');
  if (!btn || btn.disabled) return;

  const isBuyNow = btn.classList.contains('shopify-payment-button__button');
  const form = btn.closest('form');
  const productForm = btn.closest('product-form');
  const container = productForm?.closest('product-info') || btn.closest('quick-add-modal') || document;
  if (form) {

    const sizeInputs = getSizeInputs(container);
    const hasSizeField = sizeInputs.length > 0;
    const sizeSelected = !hasSizeField || sizeInputs.some(el =>
      el.tagName === 'SELECT' ? el.value !== '' : el.checked
    );
    
    if (!sizeSelected) {
      // 1. Instantly prevent form submission and stop all event propagation (bypasses Shopify handlers)
      e.preventDefault();
      e.stopPropagation();

      // If mobile width (< 750px) and NOT inside quick view/add modal, intercept and open bottom sheet
      const isQuickView = !!btn.closest('quick-add-modal') || !!btn.closest('.quick-add-modal') || !!btn.closest('.quickadd-modal');
      if (window.innerWidth < 750 && !isQuickView) {
        document.querySelectorAll('.sticky-error-toast').forEach(el => el.remove());
        openMobileSizeSheet(container, btn);
        return;
      }

      // Show floating sticky error toast directly over desktop sticky bar
      if (!isQuickView && typeof window.showStickyErrorMessage === 'function') {
        window.showStickyErrorMessage('Please select your size*');
      }

      // 2. Highlight, shake and display "Please select your size*" (Superkicks style)
      const sizeFieldset = container.querySelector('fieldset[data-option-name*="size" i], [data-option-name*="size" i]');
      if (sizeFieldset) {
        sizeFieldset.classList.add('size-validation-error');

        let errMsg = sizeFieldset.querySelector('.size-error-message');
        if (!errMsg) {
          errMsg = document.createElement('div');
          errMsg.className = 'size-error-message';
          errMsg.textContent = 'Please select your size*';
          
          const label = sizeFieldset.querySelector('.form__label') || sizeFieldset.querySelector('legend');
          if (label) {
            label.appendChild(errMsg);
          } else {
            sizeFieldset.insertBefore(errMsg, sizeFieldset.firstChild);
          }
        }
      }
      return;
    }
  }


  // Size is selected — show loading spinner immediately (0ms)
//   if (!isBuyNow) {
//     btn.classList.add('loading');
//     btn.setAttribute('aria-disabled', 'true');
//     const spinner = btn.querySelector('.loading__spinner');
//     if (spinner) spinner.classList.remove('hidden');
//     const btnText = btn.querySelector('span');
//     if (btnText) btnText.style.display = 'none';
//   }
// }, true); // capture phase = fires before form submit

if (isBuyNow) {
  e.preventDefault();
  e.stopImmediatePropagation();
    onBuyNowClick(btn);
  return;
}
 }, true);

function openMobileSizeSheet(container, originalSubmitBtn) {
  // 1. Find or create overlay
  let overlay = document.querySelector('.mobile-size-sheet-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'mobile-size-sheet-overlay';
    overlay.innerHTML = `
      <div class="mobile-size-sheet-container">
        <button type="button" class="mobile-size-sheet-close-btn" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <div class="mobile-size-sheet-title">APPAREL SIZE</div>
        <div class="mobile-size-sheet-error">Please select your size*</div>
        <div class="mobile-size-sheet-options"></div>
        <div class="mobile-size-sheet-divider"></div>
        <div class="mobile-size-sheet-footer">
          <div class="mobile-size-sheet-price-container">
            <div class="mobile-size-sheet-price"></div>
            <div class="mobile-size-sheet-tax">MRP inclusive of all Taxes</div>
          </div>
          <button type="button" class="mobile-size-sheet-submit-btn">ADD TO CART</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);

    // Event listener for close buttons
    overlay.querySelector('.mobile-size-sheet-close-btn').addEventListener('click', () => {
      overlay.classList.remove('active');
    });
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.classList.remove('active');
      }
    });
  }

  // Update original submit button reference to use when clicking "ADD TO CART" in the popup
  overlay.originalSubmitBtn = originalSubmitBtn;
  overlay.originalContainer = container;

  // 2. Fetch size inputs & render size buttons inside options container
  const optionsWrapper = overlay.querySelector('.mobile-size-sheet-options');
  optionsWrapper.innerHTML = '';

  const sizeInputs = getSizeInputs(container);

  // Determine option name for title
  let sizeOptionName = 'APPAREL SIZE';
  if (sizeInputs.length > 0) {
    const firstInput = sizeInputs[0];
    const fieldset = firstInput.closest('fieldset');
    if (fieldset) {
      const dataOptName = fieldset.getAttribute('data-option-name');
      if (dataOptName) sizeOptionName = dataOptName.toUpperCase();
    }
  }
  overlay.querySelector('.mobile-size-sheet-title').textContent = sizeOptionName;

  // Extract unique size values
  const sizes = [];
  const seenValues = new Set();
  sizeInputs.forEach(el => {
    if (el.tagName === 'SELECT') {
      Array.from(el.options).forEach(opt => {
        if (opt.value && opt.value !== '' && !seenValues.has(opt.value)) {
          seenValues.add(opt.value);
          sizes.push({
            value: opt.value,
            label: opt.value,
            checked: opt.selected,
            disabled: opt.disabled
          });
        }
      });
    } else {
      // Radio buttons
      if (!seenValues.has(el.value)) {
        seenValues.add(el.value);
        sizes.push({
          value: el.value,
          label: el.value,
          checked: el.checked,
          disabled: el.disabled || el.classList.contains('disabled')
        });
      }
    }
  });

  // Render option items
  sizes.forEach(sz => {
    const optBtn = document.createElement('div');
    optBtn.className = `mobile-size-sheet-option${sz.checked ? ' active' : ''}${sz.disabled ? ' disabled' : ''}`;
    optBtn.textContent = sz.label;
    optBtn.dataset.value = sz.value;

    if (!sz.disabled) {
      optBtn.addEventListener('click', () => {
        // Toggle active visual state in bottom sheet
        optionsWrapper.querySelectorAll('.mobile-size-sheet-option').forEach(btn => btn.classList.remove('active'));
        optBtn.classList.add('active');

        // Select on the page
        selectSizeOnPage(container, sz.value);

        // Hide red error message
        overlay.querySelector('.mobile-size-sheet-error').style.display = 'none';

        // Update price in bottom sheet after a short timeout (allowing variant select change to trigger price updates)
        setTimeout(() => {
          updateBottomSheetPrice(overlay, container);
        }, 100);
      });
    }
    optionsWrapper.appendChild(optBtn);
  });

  // 3. Update Price in bottom sheet
  updateBottomSheetPrice(overlay, container);

  // 4. Reset error visibility (initially visible because they clicked Add to Cart without selecting)
  overlay.querySelector('.mobile-size-sheet-error').style.display = 'block';

  // 5. Setup submit button action
  const submitBtn = overlay.querySelector('.mobile-size-sheet-submit-btn');
  const isBuyNow = originalSubmitBtn.classList.contains('shopify-payment-button__button');
  submitBtn.textContent = isBuyNow ? 'BUY IT NOW' : 'ADD TO CART';
  // Remove any existing click listeners by cloning and replacing
  const newSubmitBtn = submitBtn.cloneNode(true);
  submitBtn.parentNode.replaceChild(newSubmitBtn, submitBtn);

  newSubmitBtn.addEventListener('click', () => {
    const selectedOpt = optionsWrapper.querySelector('.mobile-size-sheet-option.active');
    if (!selectedOpt) {
      overlay.querySelector('.mobile-size-sheet-error').style.display = 'block';
      return;
    }

    // A size is selected, proceed!
    overlay.classList.remove('active');
    // Click the main product submit button
    if (overlay.originalSubmitBtn) {
      overlay.originalSubmitBtn.click();
    }
  });

  // 6. Show the overlay (use small delay to trigger slide up animation)
  setTimeout(() => {
    overlay.classList.add('active');
  }, 10);
}

function selectSizeOnPage(container, sizeValue) {
  const sizeInputs = getSizeInputs(container);

  sizeInputs.forEach(el => {
    if (el.tagName === 'SELECT') {
      if (el.value !== sizeValue) {
        el.value = sizeValue;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      if (el.value === sizeValue) {
        if (!el.checked) {
          el.checked = true;
          el.dispatchEvent(new Event('change', { bubbles: true }));
          // If label exists, trigger visual feedback on page
          const label = container.querySelector(`label[for="${el.id}"]`);
          if (label) {
            const parent = label.closest('fieldset, .product-form__input');
            if (parent) {
              parent.querySelectorAll('label').forEach(lbl => lbl.classList.remove('active-instant'));
              label.classList.add('active-instant');
            }
          }
        }
      }
    }
  });
}

function updateBottomSheetPrice(overlay, container) {
  const priceContainer = container.querySelector('.price');
  const priceDisplay = overlay.querySelector('.mobile-size-sheet-price');
  
  if (priceContainer && priceDisplay) {
    let priceHtml = '';
    if (priceContainer.classList.contains('price--on-sale')) {
      const salePrice = priceContainer.querySelector('.price__sale .price-item--sale');
      const regPrice = priceContainer.querySelector('.price__sale .price-item--regular');
      priceHtml = (salePrice ? salePrice.outerHTML : '') + (regPrice ? ` <s>${regPrice.innerHTML}</s>` : '');
    } else {
      const regPrice = priceContainer.querySelector('.price__regular .price-item--regular');
      priceHtml = regPrice ? regPrice.outerHTML : '';
    }
    
    if (priceHtml) {
      priceDisplay.innerHTML = priceHtml;
    }
  }
}

// Subscribing to variant change event to sync pricing in bottom sheet dynamically
if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const overlay = document.querySelector('.mobile-size-sheet-overlay');
    if (overlay && overlay.classList.contains('active') && overlay.originalContainer) {
      updateBottomSheetPrice(overlay, overlay.originalContainer);
    }
  });
}


if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.form.querySelector('[type="submit"]') || this.querySelector('[type="submit"]');
        if (!this.submitButton) return;
        this.submitButtonText = this.submitButton.querySelector('span');
        // Cache spinner directly inside the button — always the right element
        this.spinner = this.submitButton.querySelector('.loading__spinner');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Submit handler manages the spinner via this.spinner cache
        this._submitHandler = this.onSubmitHandler.bind(this);
        this.form.addEventListener('submit', this._submitHandler);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // Safety net: ensure loader is visible (click handler already shows it instantly)
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.spinner) this.spinner.classList.remove('hidden');

        const rollbackLoader = () => {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          if (this.spinner) this.spinner.classList.add('hidden');
          const btnText = this.submitButton.querySelector('span');
          if (btnText) btnText.style.display = '';
        };

        // Validate: size must be selected (Variant picker is outside the form, inside product-info)
        const container = this.closest('product-info') || this.closest('quick-add-modal') || document;
        const sizeInputs = getSizeInputs(container);

        if (sizeInputs.length > 0) {
          const sizeSelected = sizeInputs.some(el =>
            el.tagName === 'SELECT' ? el.value !== '' : el.checked
          );
          if (!sizeSelected) {
            rollbackLoader();
            this.handleErrorMessage('Please select size');

            // Highlight and shake size picker
            const sizeFieldset = container.querySelector('fieldset[data-option-name*="size" i], [data-option-name*="size" i]');
            if (sizeFieldset) {
              sizeFieldset.classList.add('size-validation-error');

              // Add text error message under the label (Superkicks style)
              let errMsg = sizeFieldset.querySelector('.size-error-message');
              if (!errMsg) {
                errMsg = document.createElement('div');
                errMsg.className = 'size-error-message';
                errMsg.textContent = 'Please select your size*';
                
                const label = sizeFieldset.querySelector('.form__label') || sizeFieldset.querySelector('legend');
                if (label) {
                  label.appendChild(errMsg);
                } else {
                  sizeFieldset.insertBefore(errMsg, sizeFieldset.firstChild);
                }
              }
            }
            return;
          }


        }

        const variantInput = this.form.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) {
          rollbackLoader();
          this.handleErrorMessage('Please select size');

          const sizeFieldset = container.querySelector('fieldset[data-option-name*="size" i], [data-option-name*="size" i]');
          if (sizeFieldset) {
            sizeFieldset.classList.add('size-validation-error');
            sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

            // Add text error message under the label (Superkicks style)
            let errMsg = sizeFieldset.querySelector('.size-error-message');
            if (!errMsg) {
              errMsg = document.createElement('div');
              errMsg.className = 'size-error-message';
              errMsg.textContent = 'Please select your size*';
              
              const label = sizeFieldset.querySelector('.form__label') || sizeFieldset.querySelector('legend');
              if (label) {
                label.appendChild(errMsg);
              } else {
                sizeFieldset.insertBefore(errMsg, sizeFieldset.firstChild);
              }
            }
          }
          return;
        }




        this.error = false;
        this.handleErrorMessage();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          // Use product canonical URL instead of window.location.pathname.
          // This stops rendering the whole homepage/collection page and keeps response times as fast as PDP (<400ms!)
          const productInfo = this.closest('product-info');
          const productUrl = productInfo?.dataset.url || window.routes?.cart_url || '/cart';

          // Extract product handle to populate ShopifyAnalytics and meta objects.
          // This prevents shop_events_listener.js from requesting /products/null.json 404s (5x requests), saving network connections and CPU.
          if (productUrl && productUrl.includes('/products/')) {
            const urlParts = productUrl.split('/');
            const productHandle = urlParts[urlParts.length - 1].split('?')[0];
            if (productHandle) {
              window.ShopifyAnalytics = window.ShopifyAnalytics || {};
              window.ShopifyAnalytics.meta = window.ShopifyAnalytics.meta || {};
              window.ShopifyAnalytics.meta.product = window.ShopifyAnalytics.meta.product || {};
              window.ShopifyAnalytics.meta.product.handle = productHandle;

              window.meta = window.meta || {};
              window.meta.product = window.meta.product || {};
              window.meta.product.handle = productHandle;
            }
          }

          // Only request sections whose DOM mount actually exists on this page.
          // Sending non-existent sections wastes Shopify server-render time.
         const essentialSectionIds = ['cart-drawer', 'cart-icon-bubble']; // adjust to your section IDs
const sectionsToRequest = this.cart.getSectionsToRender()
  .filter((section) => essentialSectionIds.includes(section.id))
  .filter((section) => document.getElementById(section.id) || (section.selector && document.querySelector(section.selector)))
  .map((section) => section.id)
  .join(',');
          if (sectionsToRequest) formData.append('sections', sectionsToRequest);
          formData.append('sections_url', window.routes?.cart_url || '/cart');
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        const fetchUrl = routes.cart_add_url.endsWith('.js') ? routes.cart_add_url : `${routes.cart_add_url}.js`;
        fetch(fetchUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
           } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred, response);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred, response);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }
            this.error = false;

            // Start modal close immediately (don't wait for cart render)
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) quickAddModal.hide(true);

            // Render cart drawer immediately — in parallel with modal close animation
            CartPerformance.measure('add:paint-updated-sections', () => {
              this.cart.renderContents(response);
            });
          })
          .catch((e) => {
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.spinner) this.spinner.classList.add('hidden');
            const btnText = this.submitButton.querySelector('span');
            if (btnText) btnText.style.display = '';
            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        const isMobile = window.innerWidth < 750;
        const mobileStickyCart = document.querySelector('.mobile-sticky-cart');
        const isQtyLimitError = errorMessage && (errorMessage.toLowerCase().includes('maximum quantity') || errorMessage.toLowerCase().includes('already in your cart'));
        const shouldShowInlineError = errorMessage && !(isMobile && mobileStickyCart && isQtyLimitError);

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (this.errorMessageWrapper) {
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !shouldShowInlineError);

          if (shouldShowInlineError && this.errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }

        const isQuickView = !!this.closest('quick-add-modal') || !!this.closest('.quick-add-modal') || !!this.closest('.quickadd-modal');
        if (errorMessage && !isQuickView && typeof window.showStickyErrorMessage === 'function') {
          window.showStickyErrorMessage(errorMessage);
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

     resolveCartLinesUpdate(deferred, cartResponse) {
  if (!deferred) return;
  const { CartLinesUpdateEvent } = window.StandardEvents || {};
  if (!CartLinesUpdateEvent) return;

  if (cartResponse?.currency) {
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cartResponse) });
  } else {
    deferred.reject(new Error('Missing currency in cart response'));
  }
}

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
